import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { IdleTimeoutService, ThemeService } from '@app/core';

@Component({
  selector: 'app-spryfox-fapi-root',
  template: `<router-outlet></router-outlet>
    <app-database-wakeup-notice></app-database-wakeup-notice>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppComponent {
  constructor() {
    // Applies the colour scheme kept in the browser before the first page.
    inject(ThemeService);
    // Signs out after 30 minutes without activity.
    inject(IdleTimeoutService);
  }
}
